import { ExperiencesTabType } from '../../../types/experiences-tab.type';
import { ExperiencesTabEnum } from '../../../types/experiences-tab.enum';

export const ExperiencesTabs: ExperiencesTabType[] = [
    {
        tab: ExperiencesTabEnum.WELLBEING_CONSULTATIONS,
        image: 'lanai-wellbeing-consultations.png',
    },
    {
        tab: ExperiencesTabEnum.SPA_SERVICES,
        image: 'lanai-spa-services.png',
    },
    {
        tab: ExperiencesTabEnum.ISLAND_ACTIVITIES,
        image: 'lanai-island-activities.png',
    },
    {
        tab: ExperiencesTabEnum.SALON_SERVICES,
        image: 'lanai-salon-services.png',
    },
];
